module.exports = {
      id: "lifestyle-usage",
      viewBox: "0 0 24.217 32.155",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#lifestyle",
      toString: function () {
        return this.url;
      }
    }